/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Highlight_Next_EventInputs */

const en_shortcut_keys_desc_highlight_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Highlight_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add next Event to Selected Events`)
};

const fr_shortcut_keys_desc_highlight_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Highlight_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter l'evenement suivant aux evenements selectionnes`)
};

const de_shortcut_keys_desc_highlight_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Highlight_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge das nächste Ereignis zu den ausgewählten Ereignissen hinzu`)
};

const it_shortcut_keys_desc_highlight_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Highlight_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi il prossimo evento agli eventi selezionati`)
};

const ru_shortcut_keys_desc_highlight_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Highlight_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить следующее событие в список выбранных событий`)
};

const es_shortcut_keys_desc_highlight_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Highlight_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar el próximo evento a los eventos seleccionados`)
};

const zh_cn2_shortcut_keys_desc_highlight_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Highlight_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将下一个事件添加到已选事件`)
};

const ja_shortcut_keys_desc_highlight_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Highlight_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントに次のイベントを追加`)
};

const hi_shortcut_keys_desc_highlight_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Highlight_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित इवेंट्स में अगला इवेंट जोड़ें`)
};

const pt_pt2_shortcut_keys_desc_highlight_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Highlight_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar o próximo evento aos eventos selecionados`)
};

/**
* | output |
* | --- |
* | "Add next Event to Selected Events" |
*
* @param {Shortcut_Keys_Desc_Highlight_Next_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_highlight_next_event = /** @type {((inputs?: Shortcut_Keys_Desc_Highlight_Next_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Highlight_Next_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_highlight_next_event(inputs)
	if (locale === "de") return de_shortcut_keys_desc_highlight_next_event(inputs)
	if (locale === "it") return it_shortcut_keys_desc_highlight_next_event(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_highlight_next_event(inputs)
	if (locale === "es") return es_shortcut_keys_desc_highlight_next_event(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_highlight_next_event(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_highlight_next_event(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_highlight_next_event(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_highlight_next_event(inputs)
	return en_shortcut_keys_desc_highlight_next_event(inputs)
});